import { createFileRoute } from "@tanstack/react-router";

import { queryClient } from "@/main";
import { customerStateWidgetQueryOptions } from "@/features-root-user/service/dashboard";
import LeadsManagement from "@/features-root-user/leads";

export const Route = createFileRoute(
  "/_root/root-user/customer/leads-management",
)({
  component: LeadsManagement,
  loader: async () => {
    queryClient.ensureQueryData(customerStateWidgetQueryOptions);
  },
});
